import { normalizeReportTypeKey } from "@/utils/reportTypeRules"

/**
 * Report-ready notification preview art.
 * Served from `public/assets/notification-reports/` (no spaces — CRA 500s on spaced paths).
 * Source masters live in `public/assets/* report - notification image.png`.
 */
export const NOTIFICATION_REPORT_READY_IMAGE = {
  "trade-analysis": "/assets/notification-reports/performance-review.png",
  "market-context-performance": "/assets/notification-reports/entry-analysis.png",
  "trade-management": "/assets/notification-reports/exit-placement.png",
} as const

export type NotificationReportReadyImageKey = keyof typeof NOTIFICATION_REPORT_READY_IMAGE

/** Resolve preview image for a report_ready payload; null when type unknown. */
export function getReportReadyNotificationImageSrc(
  details: unknown
): string | null {
  if (!details || typeof details !== "object" || Array.isArray(details)) {
    return null
  }
  const obj = details as Record<string, unknown>
  const raw =
    (typeof obj.report_type === "string" && obj.report_type.trim()) ||
    (typeof obj.reportType === "string" && obj.reportType.trim()) ||
    ""
  if (!raw) return null
  const key = normalizeReportTypeKey(raw) as NotificationReportReadyImageKey
  return NOTIFICATION_REPORT_READY_IMAGE[key] ?? null
}
